import { Button } from '@/components/ui/button'

export const FinalCTASection = () => {
  return (
    <section
      id="final-cta"
      className="relative bg-gradient-to-br from-[#FF6B00] to-[#FFD700] py-16 md:py-24 lg:py-36 overflow-hidden"
    >
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
          {/* Badges */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-8 md:mb-12">
            <div className="bg-black text-[#FFD700] px-6 py-2 md:px-8 md:py-2.5 rounded-full font-heading font-bold text-xs md:text-sm uppercase tracking-wider shadow-xl transform rotate-1">
              🔥 Vagas Limitadas
            </div>
            <div className="bg-black text-[#FFD700] px-6 py-2 md:px-8 md:py-2.5 rounded-full font-heading font-bold text-xs md:text-sm uppercase tracking-wider shadow-xl transform -rotate-1">
              ⚠️ Avaliação Obrigatória
            </div>
          </div>

          {/* Title */}
          <h2 className="font-heading font-black text-3xl sm:text-4xl md:text-6xl lg:text-7xl text-white leading-[1.05] mb-6 md:mb-8 uppercase text-shadow-lg text-balance drop-shadow-2xl">
            Sua última chance de entrar na Elite.
          </h2>

          {/* Subtitle / Urgency Copy */}
          <p className="font-sans font-semibold text-lg sm:text-xl md:text-2xl text-white/95 mb-10 md:mb-14 max-w-3xl leading-relaxed text-balance drop-shadow-md">
            O mercado não espera. As vagas estão sendo preenchidas enquanto você
            lê isso. Garanta seu acesso ao método que está criando milionários.
          </p>

          {/* CTA Button */}
          <Button
            asChild
            className="bg-black hover:bg-gray-900 text-white font-heading font-bold text-lg sm:text-xl md:text-2xl h-16 md:h-[84px] px-8 md:px-16 rounded-xl w-full sm:w-auto transition-all duration-300 hover:scale-105 hover:shadow-[0_20px_40px_rgba(0,0,0,0.3)] shadow-2xl mb-6 md:mb-8 border-2 border-transparent hover:border-[#FFD700] uppercase tracking-wide whitespace-normal text-center py-2"
          >
            <a
              href="https://wa.me/558393917008?text=Fala%20Lucas%2C%20gostaria%20de%20saber%20mais%20sobre%20a%20mentoria%20OFM%20ELITE%21"
              target="_blank"
              rel="noopener noreferrer"
            >
              Garantir Minha Vaga Agora
            </a>
          </Button>

          {/* Disclaimer */}
          <p className="font-sans text-xs sm:text-sm text-white/90 font-medium tracking-wide uppercase opacity-80">
            ⚠️ Clique apenas se estiver 100% comprometido
          </p>
        </div>
      </div>

      {/* Background Texture/Noise Overlay */}
      <div className="absolute inset-0 bg-white/10 pointer-events-none mix-blend-soft-light" />
      <div className="absolute top-0 left-0 w-full h-24 md:h-32 bg-gradient-to-b from-black/20 to-transparent pointer-events-none" />
    </section>
  )
}
